export default __webpack_public_path__ + "static/media/CTA.8cdd432b.png";